export default "__VITE_ASSET__CPRiI$8S__"